import { render, staticRenderFns } from "./MyIconComponent.vue?vue&type=template&id=9951c2ec&scoped=true"
import script from "./MyIconComponent.vue?vue&type=script&lang=js"
export * from "./MyIconComponent.vue?vue&type=script&lang=js"
import style0 from "./MyIconComponent.vue?vue&type=style&index=0&id=9951c2ec&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9951c2ec",
  null
  
)

export default component.exports